export default () => ({
  updateState(event) {
    if (!event.detail) return;

    this.$root.innerHTML = event.detail;
  },
});
